<template>
  <div v-if="opts" class="message-modal">
    <div class="close" @click="close()">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.22037 1.28002C-0.0734566 0.986194 -0.0734566 0.511071 0.22037 0.22037C0.514196 -0.0703308 0.98932 -0.0734566 1.28002 0.22037L6 4.94035L10.72 0.22037C11.0138 -0.0734566 11.4889 -0.0734566 11.7796 0.22037C12.0703 0.514196 12.0735 0.98932 11.7796 1.28002L7.05965 6L11.7796 10.72C12.0735 11.0138 12.0735 11.4889 11.7796 11.7796C11.4858 12.0703 11.0107 12.0735 10.72 11.7796L6 7.05965L1.28002 11.7796C0.986194 12.0735 0.511071 12.0735 0.22037 11.7796C-0.0703308 11.4858 -0.0734566 11.0107 0.22037 10.72L4.94035 6L0.22037 1.28002Z" fill="white"/>
      </svg>
    </div>

    <div class="message-content">
      <h3 v-if="opts.heading">{{ opts.heading }}</h3>
      <p v-if="opts.message">{{ opts.message }}</p>
      <button v-if="opts.action" :class="opts.action.class" @click="trigger()">{{ opts.action.label }}</button>

      <div class="share" v-if="opts.share">
        <div class="social-btn twitter" @click="share('twitter')">
          <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.7497 0H18.8179L12.1165 7.62404L20 18H13.8288L8.99174 11.7087L3.46371 18H0.391134L7.55758 9.84375L0 0H6.32768L10.6953 5.75048L15.7497 0ZM14.6719 16.174H16.3711L5.402 1.73077H3.57671L14.6719 16.174Z" fill="black"/>
          </svg>
        </div>

        <div class="social-btn facebook" @click="share('facebook')">
          <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.71512 12.8605V22H7.48714V12.8605H11.0456L11.7861 8.6582H7.48714V7.17148C7.48714 4.95 8.32225 4.09922 10.4779 4.09922C11.1484 4.09922 11.6873 4.11641 12 4.15078V0.339453C11.4117 0.171875 9.97189 0 9.1409 0C4.74323 0 2.71512 2.16992 2.71512 6.84922V8.6582H0V12.8605H2.71512Z" fill="black"/>
          </svg>
        </div>

        <div class="social-btn linkedin" @click="share('linkedin')">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.47768 20H0.330357V6.64732H4.47768V20ZM2.40179 4.82589C1.07589 4.82589 0 3.72768 0 2.40179C0 1.76339 0.254464 1.15625 0.705357 0.705357C1.15625 0.254464 1.76786 0 2.40179 0C3.03571 0 3.64732 0.254464 4.09821 0.705357C4.54911 1.15625 4.80357 1.76786 4.80357 2.40179C4.80357 3.72768 3.72768 4.82589 2.40179 4.82589ZM19.9955 20H15.8571V13.5C15.8571 11.9509 15.8259 9.96429 13.7009 9.96429C11.5446 9.96429 11.2143 11.6473 11.2143 13.3884V20H7.07143V6.64732H11.0491V8.46875H11.1071C11.6607 7.41964 13.0134 6.3125 15.0313 6.3125C19.2277 6.3125 20 9.07589 20 12.6652V20H19.9955Z" fill="black"/>
          </svg>
        </div>
        
        <div class="social-btn" @click="share('link')">
          <transition name="fade">
            <div v-show="hasCopied" class="copied-msg">
              Link copied to clipboard
            </div>
          </transition>
          <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.2075 2.71307C17.487 2.71307 16.7882 2.90384 16.1762 3.25145C15.4905 2.57318 14.6918 2.00513 13.8108 1.57697C15.0347 0.559571 16.5929 0 18.2075 0C21.9575 0 25 2.96743 25 6.63431C25 8.39357 24.2839 10.0808 23.0122 11.3228L19.9262 14.3369C18.6545 15.579 16.9271 16.2784 15.1259 16.2784C11.3759 16.2784 8.33333 13.311 8.33333 9.64413C8.33333 9.58054 8.33333 9.51696 8.33767 9.45337C8.35937 8.70303 8.9974 8.11379 9.76562 8.13498C10.5339 8.15618 11.1372 8.77934 11.1155 9.52967C11.1155 9.56783 11.1155 9.60598 11.1155 9.63989C11.1155 11.8061 12.9123 13.5611 15.1302 13.5611C16.1936 13.5611 17.2135 13.1499 17.9687 12.4123L21.0547 9.39826C21.8056 8.66488 22.2309 7.66444 22.2309 6.62584C22.2309 4.45962 20.434 2.7046 18.2161 2.7046L18.2075 2.71307ZM11.9444 5.98996C11.862 5.95605 11.7795 5.90942 11.7057 5.85855C11.1589 5.583 10.5339 5.42615 9.87847 5.42615C8.8151 5.42615 7.79514 5.83735 7.03993 6.57497L3.95399 9.58902C3.20312 10.3224 2.77778 11.3228 2.77778 12.3614C2.77778 14.5277 4.57465 16.2827 6.79253 16.2827C7.50868 16.2827 8.20746 16.0962 8.81944 15.7485C9.50521 16.4268 10.3038 16.9949 11.1892 17.423C9.96528 18.4362 8.41146 19 6.79253 19C3.04253 19 0 16.0326 0 12.3657C0 10.6064 0.716146 8.91923 1.98785 7.67715L5.07378 4.6631C6.34549 3.42102 8.07292 2.72155 9.87413 2.72155C13.6328 2.72155 16.6667 5.71441 16.6667 9.37282C16.6667 9.42793 16.6667 9.48304 16.6667 9.53815C16.6493 10.2885 16.0113 10.8777 15.2431 10.8608C14.4748 10.8438 13.8715 10.2207 13.8889 9.47033C13.8889 9.43641 13.8889 9.40674 13.8889 9.37282C13.8889 7.94422 13.1076 6.68942 11.9444 5.99844V5.98996Z" fill="black"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        hasCopied: false
      }
    },

    props: {
      opts: {
        type: Object,
        default: null
      },
    },

    computed: {
      hasApp() {
        return this.$store.getters.hasApp;
      },
    },

    methods: {
      close() {
        this.$emit('close');
      },

      trigger() {
        switch (this.opts.action.type) {
          case 'close': 
            this.close();
            return;
          case 'pro':
            this.EventBus.$emit('modal:go-pro')
            return;
          default: return;
        }
      },

      share(type) {
        let newFacebookWindow;
        let newTwitterWindow;
        let newLinkedInWindow;
        let link = `${this.opts.share.url}`;
        let buildTweet = this.opts.share.message ?? `Hey! I've discovered Nourish, a new, better way to read the news. Check it out!`;

        let linkedInUrl;
        let facebookUrl;
        let twitterUrl;
        let dummy = document.createElement('input');

        switch (type) {
          case 'twitter':
            twitterUrl = `https://twitter.com/share?text=${buildTweet}&url=${link}`;
            newTwitterWindow = window.open(`${twitterUrl}`, '_blank');
            if (newTwitterWindow) {
              newTwitterWindow.focus();
            }
            break;
          case 'facebook':
            facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${link}`;
            newFacebookWindow = window.open(`${facebookUrl}`, '_blank');
            if (newFacebookWindow) {
              newFacebookWindow.focus();
            }
            break;
          case 'linkedin':
            linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${link}`
            newLinkedInWindow = window.open(`${linkedInUrl}`, '_blank');
            if (newLinkedInWindow) {
              newLinkedInWindow.focus();
            }
            break
          case 'link':
            document.body.appendChild(dummy);
            dummy.value = link;
            dummy.select();
            document.execCommand('copy');
            document.body.removeChild(dummy);
            this.hasCopied = true;
            setTimeout(() => {
              this.hasCopied = false;
            }, 4000);
            break;
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .message-modal {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 1.5rem 1.5rem 2.5rem 1.5rem;
    color: white;
    background: black;
    border-top: 1px solid rgba($neutral-400, 0.25);
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    max-width: 900px;
    margin: 0 auto;
    
    .tablet &,
    .desktop & {
      border-left: 1px solid rgba($neutral-400, 0.25);
      border-right: 1px solid rgba($neutral-400, 0.25);
    }

    .tab-bar & {
      bottom: 67px;
    }

    .close {
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: flex-end;
      width: 44px;
      height: 44px;
      background: black;
      border: 1px solid rgba($neutral-400, 0.2);
      border-radius: 500px;
      cursor: pointer;
    }

    .message-content {
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      width: 100%;

      h3 {
        font-family: 'Brawler';
        font-weight: normal;
        font-size: 1.4rem;
        text-align: center;
      }

      p {
        font-size: 1rem;
        text-align: center;
      }

      button {
        display: flex;
        justify-content: center;
        gap: 0.5rem;
        height: 55px;
        border-radius: 10px;
        font-size: 1rem;
        padding-top: 1.2rem;
        width: 100%;
        max-width: 20rem;
        align-self: center;

        &:hover {
          transform: scale(1);
        }

        &.pro {
          background: $green-tone-3;
          color: $green-tone-6;
        }
      }

      .share {
        display: flex;
        justify-content: center;
        gap: 2rem;
        margin-top: 0.5rem;

        .social-btn {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 55px;
          height: 55px;
          padding-bottom: 2px;
          background: $yellow-tone-3;
          border-radius: 500px;
          cursor: pointer;
          @include transition;

          &:hover {
            transform: scale(1.1);
          }

          svg path {
            fill: black;
          }

          &.linkedin,
          &.facebook {
            svg path {
              fill: white;
            }
          }

          &.twitter {
            background: white;
          }

          &.linkedin {
            background: #0077B5;
          }

          &.facebook {
            background: #1877F2;
          }
        }

        .copied-msg {
          display: flex;
          align-items: center;
          position: absolute;
          bottom: 0;
          top: 0;
          right: 0;
          padding: 0 1.25rem 0.25rem 1.25rem;
          font-size: 0.9rem;
          font-weight: bold;
          text-align: center;
          white-space: nowrap;
          border-radius: 500px;
          background: $yellow-tone-3;
          z-index: 999;
          box-shadow: 0 0 20px 0 rgba($neutral-100, 0.2);
          @include transition;
          color: $neutral-600;

          .darkmode & {
            color: $neutral-100;
          }
        }
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>